module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("htiAA"))).then(() => parcelRequire('1iHdE'));